import { Toaster as Sonner, type ToasterProps } from 'sonner';

/** Transient notices, bottom right, on the card surface with the design's border, radius and shadow. */
const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme="light"
            position="bottom-right"
            offset={24}
            gap={8}
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast: 'font-sans! rounded-lg! border-border! shadow-lg!',
                    title: 'text-foreground!',
                    description: 'text-muted-foreground!',
                },
            }}
            style={
                {
                    '--normal-bg': 'var(--card)',
                    '--normal-text': 'var(--foreground)',
                    '--normal-border': 'var(--border)',
                    '--success-bg': 'var(--card)',
                    '--success-text': 'var(--success)',
                    '--success-border': 'var(--border)',
                    '--warning-bg': 'var(--card)',
                    '--warning-text': 'var(--warning)',
                    '--warning-border': 'var(--border)',
                    '--error-bg': 'var(--card)',
                    '--error-text': 'var(--destructive)',
                    '--error-border': 'var(--border)',
                    '--border-radius': '10px',
                    '--width': '362px',
                } as React.CSSProperties
            }
            {...props}
        />
    );
};

export { Toaster };
